{
  "organization": {
    "owner": {
      "name": {
        "short": "Besitzer",
        "long": "Organisationsbesitzer"
      },
      "description": "Erteilt volle Berechtigungen auf die Organisation, darunter:<1/>• Verwaltung der Einstellungen, Mitglieder und Teams<1/>• Löschen der Organisation<1/>• Alle untig aufgeführten Berechtigungen"
    },
    "project-creator": {
      "name": {
        "short": "Projekt-Ersteller",
        "long": "Projekt-Ersteller"
      },
      "description": "Erteilt die Berechtigung Projekte zu erstellen, sowie alle Rechte der Mitglied Rolle."
    },
    "member": {
      "name": {
        "short": "Mitglied",
        "long": "Organisationsmitglied"
      },
      "description": "Erteilt Lesezugriff auf die Organisation (Einstellungen, Mitglieder und Teams) und den Projekten zu denen sie gehören."
    },
    "read-only": {
      "name": {
        "short": "Lesezugriff",
        "long": "Organisationslesezugriff"
      },
      "description": "Erteilt Lesezugriff auf alle Projekte und Services innerhalb der Organisation."
    },
    "error": "Sie haben nicht die erforderlichen Berechtigungen, um auf diese Organisation zuzugreifen"
  },
  "project": {
    "owner": {
      "name": {
        "short": "Besitzer",
        "long": "Projektbesitzer"
      },
      "description": "Erteilt volle Berechtigungen auf das Projekt, darunter:<1/>• Verwaltung der Einstellungen, Mitglieder und Teams<1/>• Löschen des Projektes<1/>• Alle untig aufgeführten Berechtigungen"
    },
    "cluster-manager": {
      "name": {
        "short": "Cluster Manager",
        "long": "Projekt Cluster Manager"
      },
      "description": "Darf Cluster erstellen, modifizieren und löschen"
    },
    "read-only": {
      "name": {
        "short": "Lese-Zugriff",
        "long": "Projekt Lese-Zugriff"
      },
      "description": "Erteilt Lesezugriff auf das Projekt und dessen Cluster."
    },
    "error": "Sie haben nicht die erforderlichen Berechtigungen, um auf dieses Projekt zuzugreifen."
  },
  "cluster": {
    "error": "Sie haben nicht die erforderlichen Berechtigungen, um auf diesen Cluster zuzugreifen"
  }
}
